export const AVAILABLE_DTE = [
'Boleta',
'Factura',
'Boleta y Factura'
]